import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { Language } from 'src/app/company/models/employee';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // Clone the request and set the new header in one step.
    if (window.localStorage.getItem("lang") == "fr") {
        var acceptLanguageHeader = 'fr-CH,fr;q=0.9,de-CH;q=0.8,de;q=0.7';
    } else {
        var acceptLanguageHeader = 'de-CH,de';
    }

    const clonedRequest = request.clone({
      headers: request.headers.set('Accept-Language', acceptLanguageHeader),
    });

    // Pass the cloned request instead of the original request to the next handle
    return next.handle(clonedRequest);
  }
}
